export const localValidate = (formState) => {
  let errors = {};

  if (formState.restrictionTypeName === '') {
    errors.restrictionTypeName = 'A selection is required'
  }

  return errors;
};

const OmeRestrictionsTypeValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default OmeRestrictionsTypeValidation;